export default (temperature) => {
  return `${Number(temperature.toFixed(0))}F`
}
